import {redirect} from "react-router-dom";
import ProductPlans from "../../../services/UkTreatmentApi/ProductPlans";

export async function action({params}) {
    await ProductPlans.delete(params.productPlanId);

    return redirect("/manage/product_plans");
}